
import Vue from 'vue';
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';

@Component
export default class LoadingSpinner extends Vue {
    @Prop({type: String, default: undefined})
    text: string | undefined;
    @Prop({type: Boolean, default: undefined})
    backdrop: boolean | undefined;

    mounted() {
        if (this.backdrop == true) {
            document.body.classList.add('disable-scroll');
        }
    }

    destroyed() {
        if (this.backdrop == true) {
            document.body.classList.remove('disable-scroll');
        }
    }
}


